import React,{useState,}from 'react'
import { Modal,Form, message, Input, Button,} from 'antd';
import UploadOne from '../../cpn/UploadOne';
import { useBnsGuiGeAddMutation } from '../../store/BnsKeJiApi';
import ModuleSelect from '../../backend/module/ModuleSelect';
function SpecAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [info,setInfo] = useState({
        bgn_content:''
    })
    const [add] = useBnsGuiGeAddMutation()
  return (
        <>
            <Button
                onClick={() => {setOpen(true)}}
                type='primary'
            >新增规格</Button>
            <Modal
                width={1000}
                open={open}
                title='新增规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();    
                            add({
                                "bsg_bg_id" : info.bsg_bg_id,
                                "bsg_bg_name" : info.bsg_bg_name,
                                "bsg_bgn_id" : info.bsg_bgn_id,
                                "bsg_bgn_name" : info.bsg_bgn_name,
                                "bsg_cid" : localStorage.getItem('eu_id'),
                                "bsg_cname" : localStorage.getItem('eu_name'),
                                "bsg_name" : info.bsg_name,
                                "bsg_price" : info.bsg_price,
                                "bsg_image" : info.bsg_image,
                            }).then((res) => {
                                if (res.data.Status === 'success') {
                                    message.info('新增成功！');
                                    setOpen(false);
                                }
                                if (res.data.Status === "fail") {
                                    message.error('新增失败！'+res.data.Message)
                                }
                            })                              
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });                    
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_add"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                >                    
                    <ModuleSelect
                        label='版本'
                        required
                        onChangeProduct={(e,f) => {
                            setInfo(prevState=>({
                                ...prevState,
                                bsg_bg_id:e,
                                bsg_bg_name:f.label
                            }))
                        }}
                        onChangeVersion={(e,f) => {
                            setInfo(prevState=>({
                                ...prevState,
                                bsg_bgn_id:e,
                                bsg_bgn_name:f.label
                            }))
                        }}
                    />
                    <Form.Item 
                        name="title" 
                        label='名称' 
                        wrapperCol={{span:10}} 
                        required

                    >
                        <Input
                             onChange={(e) => {setInfo(prevState=>({...prevState,bsg_name:e.target.value}))}}
                        />
                    </Form.Item>                     
                    <UploadOne
                        name="pic" 
                        label='图标' 
                        wrapperCol={{span:20}} 
                        fileStr={(e) => {
                            setInfo(prevState=>({...prevState,bsg_image:e}))
                        }}
                    />
                    <Form.Item 
                        name="price" 
                        label='价格' 
                        wrapperCol={{span:10}} 
                    >
                        <Input
                             onChange={(e) => {setInfo(prevState=>({...prevState,bsg_price:e.target.value}))}}
                        />
                    </Form.Item>                    
                </Form>
            </Modal>
        </>
    )
}

export default SpecAdd